"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Info;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Info(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "info"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.4,74.337h-.5V45.01a5.506,5.506,0,0,0-5.5-5.5H38.6a5.506,5.506,0,0,0-5.5,5.5v7.164a5.506,5.506,0,0,0,5.5,5.5h.5V74.337h-.5a5.506,5.506,0,0,0-5.5,5.5V87a5.506,5.506,0,0,0,5.5,5.5H61.4A5.506,5.506,0,0,0,66.9,87V79.836A5.506,5.506,0,0,0,61.4,74.337ZM61.9,87a.5.5,0,0,1-.5.5H38.6a.5.5,0,0,1-.5-.5V79.836a.5.5,0,0,1,.5-.5h3a2.5,2.5,0,0,0,2.5-2.5V55.173a2.5,2.5,0,0,0-2.5-2.5h-3a.5.5,0,0,1-.5-.5V45.01a.5.5,0,0,1,.5-.5H55.4a.5.5,0,0,1,.5.5V76.837a2.5,2.5,0,0,0,2.5,2.5h3a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,34.1A13.3,13.3,0,1,0,36.7,20.8,13.312,13.312,0,0,0,50,34.1ZM50,12.5a8.3,8.3,0,1,1-8.3,8.3A8.307,8.307,0,0,1,50,12.5Z"
  })))));
}